// 城市数据，使用标准行政区划代码格式，兼容旧项目
// 数据结构：[{ label, value, children: [{ label, value, children: [{ label, value }] }] }]

const CITIES_DATA = [
  {
    "label": "北京",
    "value": 110000,
    "children": [{
      "label": "北京市",
      "value": 110000,
      "children": [
        { "label": "东城区", "value": 110101 },
        { "label": "西城区", "value": 110102 },
        { "label": "朝阳区", "value": 110105 },
        { "label": "丰台区", "value": 110106 },
        { "label": "石景山区", "value": 110107 },
        { "label": "海淀区", "value": 110108 },
        { "label": "门头沟区", "value": 110109 },
        { "label": "房山区", "value": 110111 },
        { "label": "通州区", "value": 110112 },
        { "label": "顺义区", "value": 110113 },
        { "label": "昌平区", "value": 110114 },
        { "label": "大兴区", "value": 110115 },
        { "label": "怀柔区", "value": 110116 },
        { "label": "平谷区", "value": 110117 }
      ]
    }]
  },
  {
    "label": "天津",
    "value": 120000,
    "children": [{
      "label": "天津市",
      "value": 120000,
      "children": [
        { "label": "和平区", "value": 120101 },
        { "label": "河东区", "value": 120102 },
        { "label": "河西区", "value": 120103 },
        { "label": "南开区", "value": 120104 },
        { "label": "河北区", "value": 120105 },
        { "label": "红桥区", "value": 120106 },
        { "label": "东丽区", "value": 120110 },
        { "label": "西青区", "value": 120111 },
        { "label": "津南区", "value": 120112 },
        { "label": "北辰区", "value": 120113 },
        { "label": "武清区", "value": 120114 },
        { "label": "宝坻区", "value": 120115 }
      ]
    }]
  },
  {
    "label": "上海",
    "value": 310000,
    "children": [{
      "label": "上海市",
      "value": 310000,
      "children": [
        { "label": "黄浦区", "value": 310101 },
        { "label": "徐汇区", "value": 310104 },
        { "label": "长宁区", "value": 310105 },
        { "label": "静安区", "value": 310106 },
        { "label": "普陀区", "value": 310107 },
        { "label": "虹口区", "value": 310109 },
        { "label": "杨浦区", "value": 310110 },
        { "label": "闵行区", "value": 310112 },
        { "label": "宝山区", "value": 310113 },
        { "label": "嘉定区", "value": 310114 },
        { "label": "浦东新区", "value": 310115 },
        { "label": "金山区", "value": 310116 },
        { "label": "松江区", "value": 310117 },
        { "label": "青浦区", "value": 310118 },
        { "label": "奉贤区", "value": 310120 }
      ]
    }]
  },
  {
    "label": "重庆",
    "value": 500000,
    "children": [{
      "label": "重庆市",
      "value": 500000,
      "children": [
        { "label": "万州区", "value": 500101 },
        { "label": "涪陵区", "value": 500102 },
        { "label": "渝中区", "value": 500103 },
        { "label": "大渡口区", "value": 500104 },
        { "label": "江北区", "value": 500105 },
        { "label": "沙坪坝区", "value": 500106 },
        { "label": "九龙坡区", "value": 500107 },
        { "label": "南岸区", "value": 500108 },
        { "label": "北碚区", "value": 500109 },
        { "label": "綦江区", "value": 500110 },
        { "label": "大足区", "value": 500111 },
        { "label": "渝北区", "value": 500112 },
        { "label": "巴南区", "value": 500113 }
      ]
    }]
  },
  {
    "label": "河北省",
    "value": 130000,
    "children": [
      {
        "label": "石家庄市",
        "value": 130100,
        "children": [
          { "label": "长安区", "value": 130102 },
          { "label": "桥西区", "value": 130104 },
          { "label": "新华区", "value": 130105 },
          { "label": "井陉矿区", "value": 130107 },
          { "label": "裕华区", "value": 130108 }
        ]
      },
      {
        "label": "唐山市",
        "value": 130200,
        "children": [
          { "label": "路南区", "value": 130202 },
          { "label": "路北区", "value": 130203 },
          { "label": "古冶区", "value": 130204 },
          { "label": "开平区", "value": 130205 }
        ]
      }
    ]
  },
  {
    "label": "山西省",
    "value": 140000,
    "children": [
      {
        "label": "太原市",
        "value": 140100,
        "children": [
          { "label": "小店区", "value": 140105 },
          { "label": "迎泽区", "value": 140106 },
          { "label": "杏花岭区", "value": 140107 },
          { "label": "尖草坪区", "value": 140108 }
        ]
      },
      {
        "label": "大同市",
        "value": 140200,
        "children": [
          { "label": "城区", "value": 140202 },
          { "label": "矿区", "value": 140203 },
          { "label": "南郊区", "value": 140211 },
          { "label": "新荣区", "value": 140212 }
        ]
      }
    ]
  },
  {
    "label": "内蒙古自治区",
    "value": 150000,
    "children": [
      {
        "label": "呼和浩特市",
        "value": 150100,
        "children": [
          { "label": "新城区", "value": 150102 },
          { "label": "回民区", "value": 150103 },
          { "label": "玉泉区", "value": 150104 },
          { "label": "赛罕区", "value": 150105 }
        ]
      },
      {
        "label": "包头市",
        "value": 150200,
        "children": [
          { "label": "东河区", "value": 150202 },
          { "label": "昆都仑区", "value": 150203 },
          { "label": "青山区", "value": 150204 },
          { "label": "石拐区", "value": 150205 }
        ]
      }
    ]
  },
  {
    "label": "辽宁省",
    "value": 210000,
    "children": [
      {
        "label": "沈阳市",
        "value": 210100,
        "children": [
          { "label": "和平区", "value": 210102 },
          { "label": "沈河区", "value": 210103 },
          { "label": "大东区", "value": 210104 },
          { "label": "皇姑区", "value": 210105 }
        ]
      },
      {
        "label": "大连市",
        "value": 210200,
        "children": [
          { "label": "中山区", "value": 210202 },
          { "label": "西岗区", "value": 210203 },
          { "label": "沙河口区", "value": 210204 },
          { "label": "甘井子区", "value": 210211 }
        ]
      }
    ]
  },
  {
    "label": "吉林省",
    "value": 220000,
    "children": [
      {
        "label": "长春市",
        "value": 220100,
        "children": [
          { "label": "南关区", "value": 220102 },
          { "label": "宽城区", "value": 220103 },
          { "label": "朝阳区", "value": 220104 },
          { "label": "二道区", "value": 220105 }
        ]
      },
      {
        "label": "吉林市",
        "value": 220200,
        "children": [
          { "label": "昌邑区", "value": 220202 },
          { "label": "龙潭区", "value": 220203 },
          { "label": "船营区", "value": 220204 },
          { "label": "丰满区", "value": 220211 }
        ]
      }
    ]
  },
  {
    "label": "黑龙江省",
    "value": 230000,
    "children": [
      {
        "label": "哈尔滨市",
        "value": 230100,
        "children": [
          { "label": "道里区", "value": 230102 },
          { "label": "南岗区", "value": 230103 },
          { "label": "道外区", "value": 230104 },
          { "label": "平房区", "value": 230108 }
        ]
      },
      {
        "label": "齐齐哈尔市",
        "value": 230200,
        "children": [
          { "label": "龙沙区", "value": 230202 },
          { "label": "建华区", "value": 230203 },
          { "label": "铁锋区", "value": 230204 },
          { "label": "昂昂溪区", "value": 230205 }
        ]
      }
    ]
  },
  {
    "label": "江苏省",
    "value": 320000,
    "children": [
      {
        "label": "南京市",
        "value": 320100,
        "children": [
          { "label": "玄武区", "value": 320102 },
          { "label": "秦淮区", "value": 320104 },
          { "label": "建邺区", "value": 320105 },
          { "label": "鼓楼区", "value": 320106 }
        ]
      },
      {
        "label": "无锡市",
        "value": 320200,
        "children": [
          { "label": "锡山区", "value": 320205 },
          { "label": "惠山区", "value": 320206 },
          { "label": "滨湖区", "value": 320211 },
          { "label": "梁溪区", "value": 320213 }
        ]
      }
    ]
  },
  {
    "label": "浙江省",
    "value": 330000,
    "children": [
      {
        "label": "杭州市",
        "value": 330100,
        "children": [
          { "label": "上城区", "value": 330102 },
          { "label": "下城区", "value": 330103 },
          { "label": "江干区", "value": 330104 },
          { "label": "拱墅区", "value": 330105 },
          { "label": "西湖区", "value": 330106 },
          { "label": "滨江区", "value": 330108 },
          { "label": "萧山区", "value": 330109 },
          { "label": "余杭区", "value": 330110 }
        ]
      },
      {
        "label": "宁波市",
        "value": 330200,
        "children": [
          { "label": "海曙区", "value": 330203 },
          { "label": "江北区", "value": 330205 },
          { "label": "北仑区", "value": 330206 },
          { "label": "镇海区", "value": 330211 },
          { "label": "鄞州区", "value": 330212 }
        ]
      }
    ]
  },
  {
    "label": "安徽省",
    "value": 340000,
    "children": [
      {
        "label": "合肥市",
        "value": 340100,
        "children": [
          { "label": "瑶海区", "value": 340102 },
          { "label": "庐阳区", "value": 340103 },
          { "label": "蜀山区", "value": 340104 },
          { "label": "包河区", "value": 340111 }
        ]
      },
      {
        "label": "芜湖市",
        "value": 340200,
        "children": [
          { "label": "镜湖区", "value": 340202 },
          { "label": "弋江区", "value": 340203 },
          { "label": "鸠江区", "value": 340207 },
          { "label": "三山区", "value": 340208 }
        ]
      }
    ]
  },
  {
    "label": "福建省",
    "value": 350000,
    "children": [
      {
        "label": "福州市",
        "value": 350100,
        "children": [
          { "label": "鼓楼区", "value": 350102 },
          { "label": "台江区", "value": 350103 },
          { "label": "仓山区", "value": 350104 },
          { "label": "马尾区", "value": 350105 }
        ]
      },
      {
        "label": "厦门市",
        "value": 350200,
        "children": [
          { "label": "思明区", "value": 350203 },
          { "label": "海沧区", "value": 350205 },
          { "label": "湖里区", "value": 350206 },
          { "label": "集美区", "value": 350211 }
        ]
      }
    ]
  },
  {
    "label": "江西省",
    "value": 360000,
    "children": [
      {
        "label": "南昌市",
        "value": 360100,
        "children": [
          { "label": "东湖区", "value": 360102 },
          { "label": "西湖区", "value": 360103 },
          { "label": "青云谱区", "value": 360104 },
          { "label": "湾里区", "value": 360105 }
        ]
      },
      {
        "label": "景德镇市",
        "value": 360200,
        "children": [
          { "label": "昌江区", "value": 360202 },
          { "label": "珠山区", "value": 360203 },
          { "label": "浮梁县", "value": 360222 },
          { "label": "乐平市", "value": 360281 }
        ]
      }
    ]
  },
  {
    "label": "山东省",
    "value": 370000,
    "children": [
      {
        "label": "济南市",
        "value": 370100,
        "children": [
          { "label": "历下区", "value": 370102 },
          { "label": "市中区", "value": 370103 },
          { "label": "槐荫区", "value": 370104 },
          { "label": "天桥区", "value": 370105 }
        ]
      },
      {
        "label": "青岛市",
        "value": 370200,
        "children": [
          { "label": "市南区", "value": 370202 },
          { "label": "市北区", "value": 370203 },
          { "label": "黄岛区", "value": 370211 },
          { "label": "崂山区", "value": 370212 }
        ]
      }
    ]
  },
  {
    "label": "河南省",
    "value": 410000,
    "children": [
      {
        "label": "郑州市",
        "value": 410100,
        "children": [
          { "label": "中原区", "value": 410102 },
          { "label": "二七区", "value": 410103 },
          { "label": "管城回族区", "value": 410104 },
          { "label": "金水区", "value": 410105 }
        ]
      },
      {
        "label": "开封市",
        "value": 410200,
        "children": [
          { "label": "龙亭区", "value": 410202 },
          { "label": "顺河回族区", "value": 410203 },
          { "label": "鼓楼区", "value": 410204 },
          { "label": "禹王台区", "value": 410205 }
        ]
      }
    ]
  },
  {
    "label": "湖北省",
    "value": 420000,
    "children": [
      {
        "label": "武汉市",
        "value": 420100,
        "children": [
          { "label": "江岸区", "value": 420102 },
          { "label": "江汉区", "value": 420103 },
          { "label": "硚口区", "value": 420104 },
          { "label": "汉阳区", "value": 420105 }
        ]
      },
      {
        "label": "黄石市",
        "value": 420200,
        "children": [
          { "label": "黄石港区", "value": 420202 },
          { "label": "西塞山区", "value": 420203 },
          { "label": "下陆区", "value": 420204 },
          { "label": "铁山区", "value": 420205 }
        ]
      }
    ]
  },
  {
    "label": "湖南省",
    "value": 430000,
    "children": [
      {
        "label": "长沙市",
        "value": 430100,
        "children": [
          { "label": "芙蓉区", "value": 430102 },
          { "label": "天心区", "value": 430103 },
          { "label": "岳麓区", "value": 430104 },
          { "label": "开福区", "value": 430105 }
        ]
      },
      {
        "label": "株洲市",
        "value": 430200,
        "children": [
          { "label": "荷塘区", "value": 430202 },
          { "label": "芦淞区", "value": 430203 },
          { "label": "石峰区", "value": 430204 },
          { "label": "天元区", "value": 430211 }
        ]
      }
    ]
  },
  {
    "label": "广东省",
    "value": 440000,
    "children": [
      {
        "label": "广州市",
        "value": 440100,
        "children": [
          { "label": "荔湾区", "value": 440103 },
          { "label": "越秀区", "value": 440104 },
          { "label": "海珠区", "value": 440105 },
          { "label": "天河区", "value": 440106 },
          { "label": "白云区", "value": 440111 },
          { "label": "黄埔区", "value": 440112 },
          { "label": "番禺区", "value": 440113 },
          { "label": "花都区", "value": 440114 },
          { "label": "南沙区", "value": 440115 },
          { "label": "从化区", "value": 440117 },
          { "label": "增城区", "value": 440118 }
        ]
      },
      {
        "label": "深圳市",
        "value": 440300,
        "children": [
          { "label": "罗湖区", "value": 440303 },
          { "label": "福田区", "value": 440304 },
          { "label": "南山区", "value": 440305 },
          { "label": "宝安区", "value": 440306 },
          { "label": "龙岗区", "value": 440307 },
          { "label": "盐田区", "value": 440308 },
          { "label": "龙华区", "value": 440309 },
          { "label": "坪山区", "value": 440310 }
        ]
      },
      {
        "label": "东莞市",
        "value": 441900,
        "children": [
          { "label": "莞城街道", "value": 441900001 },
          { "label": "南城街道", "value": 441900002 },
          { "label": "东城街道", "value": 441900003 },
          { "label": "万江街道", "value": 441900004 }
        ]
      }
    ]
  },
  {
    "label": "广西壮族自治区",
    "value": 450000,
    "children": [
      {
        "label": "南宁市",
        "value": 450100,
        "children": [
          { "label": "兴宁区", "value": 450102 },
          { "label": "青秀区", "value": 450103 },
          { "label": "江南区", "value": 450105 },
          { "label": "西乡塘区", "value": 450107 }
        ]
      },
      {
        "label": "柳州市",
        "value": 450200,
        "children": [
          { "label": "城中区", "value": 450202 },
          { "label": "鱼峰区", "value": 450203 },
          { "label": "柳南区", "value": 450204 },
          { "label": "柳北区", "value": 450205 }
        ]
      }
    ]
  },
  {
    "label": "海南省",
    "value": 460000,
    "children": [
      {
        "label": "海口市",
        "value": 460100,
        "children": [
          { "label": "秀英区", "value": 460105 },
          { "label": "龙华区", "value": 460106 },
          { "label": "琼山区", "value": 460107 },
          { "label": "美兰区", "value": 460108 }
        ]
      },
      {
        "label": "三亚市",
        "value": 460200,
        "children": [
          { "label": "海棠区", "value": 460202 },
          { "label": "吉阳区", "value": 460203 },
          { "label": "天涯区", "value": 460204 },
          { "label": "崖州区", "value": 460205 }
        ]
      }
    ]
  },
  {
    "label": "四川省",
    "value": 510000,
    "children": [
      {
        "label": "成都市",
        "value": 510100,
        "children": [
          { "label": "锦江区", "value": 510104 },
          { "label": "青羊区", "value": 510105 },
          { "label": "金牛区", "value": 510106 },
          { "label": "武侯区", "value": 510107 }
        ]
      },
      {
        "label": "自贡市",
        "value": 510300,
        "children": [
          { "label": "自流井区", "value": 510302 },
          { "label": "贡井区", "value": 510303 },
          { "label": "大安区", "value": 510304 },
          { "label": "沿滩区", "value": 510311 }
        ]
      }
    ]
  },
  {
    "label": "贵州省",
    "value": 520000,
    "children": [
      {
        "label": "贵阳市",
        "value": 520100,
        "children": [
          { "label": "南明区", "value": 520102 },
          { "label": "云岩区", "value": 520103 },
          { "label": "花溪区", "value": 520111 },
          { "label": "乌当区", "value": 520112 }
        ]
      },
      {
        "label": "六盘水市",
        "value": 520200,
        "children": [
          { "label": "钟山区", "value": 520201 },
          { "label": "六枝特区", "value": 520203 },
          { "label": "水城县", "value": 520221 },
          { "label": "盘县", "value": 520222 }
        ]
      }
    ]
  },
  {
    "label": "云南省",
    "value": 530000,
    "children": [
      {
        "label": "昆明市",
        "value": 530100,
        "children": [
          { "label": "五华区", "value": 530102 },
          { "label": "盘龙区", "value": 530103 },
          { "label": "官渡区", "value": 530111 },
          { "label": "西山区", "value": 530112 }
        ]
      },
      {
        "label": "曲靖市",
        "value": 530300,
        "children": [
          { "label": "麒麟区", "value": 530302 },
          { "label": "马龙县", "value": 530321 },
          { "label": "陆良县", "value": 530322 },
          { "label": "师宗县", "value": 530323 }
        ]
      }
    ]
  },
  {
    "label": "西藏自治区",
    "value": 540000,
    "children": [
      {
        "label": "拉萨市",
        "value": 540100,
        "children": [
          { "label": "城关区", "value": 540102 },
          { "label": "林周县", "value": 540121 },
          { "label": "当雄县", "value": 540122 },
          { "label": "尼木县", "value": 540123 }
        ]
      },
      {
        "label": "昌都市",
        "value": 540300,
        "children": [
          { "label": "卡若区", "value": 540302 },
          { "label": "江达县", "value": 540321 },
          { "label": "贡觉县", "value": 540322 },
          { "label": "类乌齐县", "value": 540323 }
        ]
      }
    ]
  },
  {
    "label": "陕西省",
    "value": 610000,
    "children": [
      {
        "label": "西安市",
        "value": 610100,
        "children": [
          { "label": "新城区", "value": 610102 },
          { "label": "碑林区", "value": 610103 },
          { "label": "莲湖区", "value": 610104 },
          { "label": "灞桥区", "value": 610111 }
        ]
      },
      {
        "label": "铜川市",
        "value": 610200,
        "children": [
          { "label": "王益区", "value": 610202 },
          { "label": "印台区", "value": 610203 },
          { "label": "耀州区", "value": 610204 },
          { "label": "宜君县", "value": 610222 }
        ]
      }
    ]
  },
  {
    "label": "甘肃省",
    "value": 620000,
    "children": [
      {
        "label": "兰州市",
        "value": 620100,
        "children": [
          { "label": "城关区", "value": 620102 },
          { "label": "七里河区", "value": 620103 },
          { "label": "西固区", "value": 620104 },
          { "label": "安宁区", "value": 620105 }
        ]
      },
      {
        "label": "嘉峪关市",
        "value": 620200,
        "children": [
          { "label": "嘉峪关市", "value": 620201 }
        ]
      }
    ]
  },
  {
    "label": "青海省",
    "value": 630000,
    "children": [
      {
        "label": "西宁市",
        "value": 630100,
        "children": [
          { "label": "城东区", "value": 630102 },
          { "label": "城中区", "value": 630103 },
          { "label": "城西区", "value": 630104 },
          { "label": "城北区", "value": 630105 }
        ]
      },
      {
        "label": "海东市",
        "value": 630200,
        "children": [
          { "label": "乐都区", "value": 630202 },
          { "label": "平安区", "value": 630203 },
          { "label": "民和回族土族自治县", "value": 630222 },
          { "label": "互助土族自治县", "value": 630223 }
        ]
      }
    ]
  },
  {
    "label": "宁夏回族自治区",
    "value": 640000,
    "children": [
      {
        "label": "银川市",
        "value": 640100,
        "children": [
          { "label": "兴庆区", "value": 640104 },
          { "label": "西夏区", "value": 640105 },
          { "label": "金凤区", "value": 640106 },
          { "label": "永宁县", "value": 640121 }
        ]
      },
      {
        "label": "石嘴山市",
        "value": 640200,
        "children": [
          { "label": "大武口区", "value": 640202 },
          { "label": "惠农区", "value": 640205 },
          { "label": "平罗县", "value": 640221 }
        ]
      }
    ]
  },
  {
    "label": "新疆维吾尔自治区",
    "value": 650000,
    "children": [
      {
        "label": "乌鲁木齐市",
        "value": 650100,
        "children": [
          { "label": "天山区", "value": 650102 },
          { "label": "沙依巴克区", "value": 650103 },
          { "label": "新市区", "value": 650104 },
          { "label": "水磨沟区", "value": 650105 }
        ]
      },
      {
        "label": "克拉玛依市",
        "value": 650200,
        "children": [
          { "label": "独山子区", "value": 650202 },
          { "label": "克拉玛依区", "value": 650203 },
          { "label": "白碱滩区", "value": 650204 },
          { "label": "乌尔禾区", "value": 650205 }
        ]
      }
    ]
  }
]

export default CITIES_DATA